module.exports = __webpack_public_path__ + "static/media/sf-trial-2.f767db6c.mp3";